"use client";

import { useEffect } from "react";
import { affiliateAttribute } from "@introw/utils/affiliate";

// This function will be auto-called by the script tag
export const Affiliate = () => {
  useEffect(() => {
    if (typeof window !== "undefined") {
      affiliateAttribute();
    }
  }, []);

  return null;
};
